import { ca } from '@cian/analytics';

import { type IPromo } from '../../../../types/promos';
import { getProductsData } from '../../../../utils/getProductsData';

/**
 * @description Событие: клик по кнопке «Оформить онлайн» (или аналогу) у конкретного ипотечного промо.
 */
export function trackGetOnlineClick(promo: IPromo, position: number): void {
  const { promoType, uniquePromoId: promoCianMortgage } = promo;

  ca('eventSite', {
    action: 'click_get_online',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData({ position, promoCianMortgage })],
  });
}
